<!-- desktop -->
<div class="mb-10 px-3 md:px-0">
  <div class="mb-6 hidden items-center md:flex">
    <div class="mr-4 h-1 w-6 bg-primary-md-dark lg:w-12"></div>
    <div class="text-xl font-medium text-primary-darkest lg:text-3xl">
      Order Detail
    </div>
  </div>
  <div
    class="order-info mb-3 items-start gap-3 rounded-md bg-primary-lightest p-5 shadow-md lg:flex">
    <div class="oi-item order-no flex-1">
      <div class="label text-xs uppercase text-primary-darkest/50">
        ORDER NO:
      </div>
      <div class="value text-right text-primary-md-dark lg:text-left">
        ORDER#{{ order.id }}
      </div>
    </div>
    <div class="oi-item order-date flex-1">
      <div class="label text-xs uppercase text-primary-darkest/50">
        ORDER DATE:
      </div>
      <div class="value text-right lg:text-left">
        {{ order.formatted_created_date }}
      </div>
    </div>
    <div class="oi-item payment-method flex-1">
      <div class="label text-xs uppercase text-primary-darkest/50">
        Payment Method:
      </div>
      <div
        class="value text-right lg:text-left"
        *ngIf="order.checkout && order.checkout.payment_method_name">
        {{ order.checkout.payment_method_name }}
      </div>
    </div>
    <div class="oi-item status flex-1">
      <div class="label text-xs uppercase text-primary-darkest/50">Status:</div>
      <div class="value text-right lg:text-left">
        <span
          class="status-badge rounded-md bg-primary-md-dark py-0.5 px-3 text-xs text-white"
          >{{ translateOrderStatus(order.status) }}</span
        >
      </div>
    </div>
  </div>
  <div class="grid gap-4 lg:grid-cols-12">
    <div class="lg:col-span-8">
      <div class="c-btn-group mb-4" *ngIf="order.status == 2">
        <button
          class="btn-t-main"
          [ngClass]="{ 'opacity-50': accLoading }"
          [disabled]="accLoading"
          (click)="acceptOrder()">
          <span class="btn-label">Pesanan Diterima</span>
          <fa-icon
            class="load-icon"
            *ngIf="accLoading"
            [icon]="faSpinner"
            [spin]="true"></fa-icon>
        </button>
        <!-- note: report feature -->
        <!-- <button class="btn-s-main" (click)="openModal(reportModal)">
          Laporkan Pesanan
        </button> -->
      </div>
      <div
        class="product-card overflow-hidden rounded-md border border-primary-md-dark/30">
        <div
          class="pc-header flex items-center justify-between bg-primary-lightest p-3">
          <div class="title text-lg text-primary-darkest">Ordered Products</div>
          <!-- note: buy again feature -->
          <!-- <div class="button">
            <button
              class="btn-p-md-dark"
              (click)="openBuyAgainModal()"
              [disabled]="!order.id">
              Beli Lagi
            </button>
          </div> -->
        </div>
        <div class="pc-body divide-y divide-primary-md-dark/30">
          <div class="product-list divide-y divide-primary-md-dark/30">
            <div
              class="product-item flex items-center gap-3 p-3"
              *ngFor="let product of order.lines">
              <div
                class="product-img-wrapper h-[45px] w-[45px] border border-primary-md-dark/50">
                <img
                  class="h-[45px] w-[45px]"
                  [src]="
                    product.product_default_image_path &&
                    product.product_default_image_path[0].small
                      ? product.product_default_image_path[0].small.path
                      : productDefaultImg
                  "
                  alt=""
                  (error)="handleProductImgError()"
                  class="product-img" />
              </div>
              <div class="product-info flex-1 gap-3">
                <div class="product-name text-primary-darkest line-clamp-1">
                  {{ product.product_brand.name }} - {{ product.product_name }}
                </div>
                <div
                  class="product-variant text-xs text-primary-darkest/50"
                  *ngIf="product.product_variant_name">
                  Varian: {{ product.product_variant_name }}
                </div>
                <div class="product-u-price text-sm">
                  {{ product.unit_price | fcCurrency }}
                </div>
              </div>
              <div class="product-price text-primary-md-dark">
                {{ product.total | fcCurrency }}
                <div class="total-item text-xs text-primary-darkest/50">
                  {{ product.quantity }} Pcs ({{ product.unit_weight }}gr)
                </div>
              </div>
            </div>
          </div>
          <div>
            <div class="content ml-auto w-full max-w-[500px] p-3">
              <div class="os-item flex w-full items-center">
                <div class="label flex-1 text-sm text-primary-darkest/50">
                  Product Subtotals
                </div>
                <div class="value text-right text-primary-darkest">
                  {{ order.subtotal | fcCurrency }}
                </div>
              </div>
              <div class="os-item flex w-full items-center">
                <div class="label flex-1 text-sm text-primary-darkest/50">
                  Discount
                </div>
                <div class="value text-right text-primary-darkest">
                  {{ order.discount | fcCurrency }}
                </div>
              </div>
              <div class="os-item flex w-full items-center">
                <div class="label flex-1 text-sm text-primary-darkest/50">
                  Shipping Cost
                </div>
                <div class="value text-right text-primary-darkest">
                  {{ order.shipping_fee | fcCurrency }}
                </div>
              </div>
            </div>
          </div>
          <div>
            <div class="total ml-auto w-full max-w-[500px] p-3">
              <div class="os-item flex w-full items-center">
                <div
                  class="label flex-1 text-sm font-medium text-primary-darkest">
                  Order Totals
                </div>
                <div class="value text-right text-xl text-red-500">
                  {{ order.total | fcCurrency }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="order-first p-3 lg:order-last lg:col-span-4 lg:p-0">
      <div class="detailed-info mb-5 space-y-3">
        <div class="section delivery-address">
          <div class="label text-sm uppercase text-primary-darkest/50">
            Shipping Address
          </div>
          <div class="font-bold text-primary-darkest">
            {{ order.receiver_name }}
          </div>
          <div>{{ order.address }}</div>
          <div *ngIf="order.checkout">
            {{ order.checkout.postal_code }}
          </div>
          <div
            class="light mt-2"
            *ngIf="order.checkout && order.checkout.address_note">
            catatan: {{ order.checkout.address_note }}
          </div>
        </div>
        <div class="section shipping-method">
          <div class="label text-sm uppercase text-primary-darkest/50">
            SHIPPING COURIER
          </div>
          <div class="font-bold text-primary-darkest">
            {{ order.shipping_method_name }}
          </div>
          <div class="secondary-color" *ngIf="order.shipment_tracking_no">
            No Resi: {{ order.shipment_tracking_no }}
          </div>
        </div>
        <div class="section deliver-from">
          <div class="label text-sm uppercase text-primary-darkest/50">
            SENT BY
          </div>
          <div class="font-bold text-primary-darkest" *ngIf="order.shop">
            {{ order.shop.name }}
          </div>
        </div>
      </div>
      <div class="order-process">
        <div class="wrapper">
          <ul class="step space-y-3">
            <li class="step-item text-green-600">
              <div class="content flex gap-3">
                <div class="dots w-[30px]">
                  <fa-icon class="icon" [icon]="faFileAlt"></fa-icon>
                </div>
                <div class="text flex-1">
                  <div class="title font-bold">Order</div>
                  <div class="subtitle text-xs text-primary-darkest/50">
                    {{ order.formatted_created_date }}
                  </div>
                </div>
              </div>
            </li>
            <li
              class="step-item"
              [ngClass]="{
                'text-primary-darkest': order.status == 0,
                'text-green-600': order.status > 0 && order.status != 5
              }">
              <div class="content flex gap-3">
                <div class="dots w-[30px]">
                  <fa-icon class="icon" [icon]="faMoneyBill"></fa-icon>
                </div>
                <div class="text flex-1">
                  <div class="title font-bold">Payment Information</div>
                  <div class="subtitle text-xs text-primary-darkest/50">
                    {{ order.formatted_paid_date }}
                  </div>
                  <div
                    class="info text-xs text-red-500"
                    *ngIf="order.status == 0">
                    Pay before <br />{{ order.paymentDeadline }}
                  </div>
                </div>
              </div>
            </li>
            <li
              class="step-item"
              [ngClass]="{
                'text-primary-darkest opacity-50': order.status == 1,
                'text-green-600': order.status > 1 && order.status != 5
              }">
              <div class="content flex gap-3">
                <div class="dots w-[30px]">
                  <fa-icon class="icon" [icon]="faTruck"></fa-icon>
                </div>
                <div class="text flex-1">
                  <div class="title font-bold">Shipping Information</div>
                  <div class="subtitle text-xs text-primary-darkest/50">
                    {{ order.formatted_dispatch_date }}
                  </div>
                </div>
              </div>
            </li>
            <li
              class="step-item"
              [ngClass]="{
                'text-primary-darkest opacity-50': order.status == 2,
                'text-green-600': order.status > 2 && order.status != 5
              }">
              <div class="content flex gap-3">
                <div class="dots w-[30px]">
                  <fa-icon class="icon" [icon]="faCheck"></fa-icon>
                </div>
                <div class="text flex-1">
                  <div class="title font-bold">Package Received</div>
                  <div class="subtitle text-xs text-primary-darkest/50">
                    {{ order.formatted_delivered_date }}
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
